import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconZoom = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	"aria-hidden": "true",
	focusable: "false",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M17.25 1.5V6a.749.749 0 1 1-1.5 0V3.31l-4.719 4.72a.75.75 0 1 1-1.062-1.062l4.72-4.719h-2.69a.749.749 0 1 1 0-1.5h4.5a.749.749 0 0 1 .75.75ZM6.969 9.969l-4.719 4.72v-2.69a.749.749 0 1 0-1.5 0v4.5a.749.749 0 0 0 .75.75H6a.749.749 0 1 0 0-1.5H3.31l4.72-4.719a.75.75 0 1 0-1.062-1.062Z" })
});
export default SvgIconZoom;
